import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Headphones, Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 px-6 md:px-8" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="relative bg-gradient-to-br from-warm-deep to-warm-deeper rounded-3xl p-8 md:p-12 shadow-xl border border-gold/20 overflow-hidden" data-id="element-19">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-20" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-cream/40 rounded-full blur-2xl translate-y-1/4 -translate-x-1/4" data-id="element-21" />

            <div className="relative z-10" data-id="element-22">
              <div className="flex items-center gap-3 mb-6" data-id="element-23">
                <div className="bg-gold text-white p-2 rounded-full shadow-md" data-id="element-24">
                  <Gift size={20} data-id="element-25" />
                </div>
                <span className="text-gold-dark font-bold tracking-wider uppercase text-sm" data-id="element-26">
                  Regalo de Rescate
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-27">
                BONUS EXCLUSIVO: <br className="hidden md:block" data-id="element-28" />
                <span className="font-heading italic font-normal text-gold-dark" data-id="element-29">
                  Audio S.O.S. "Tu Salvavidas"
                </span>
              </h2>

              <div className="flex flex-col md:flex-row gap-8 items-center mt-8" data-id="element-30">
                <img src="https://cdn.magicpatterns.com/uploads/qG9z7ekJg3gMPyRXNX62cT/AUDIOSOS-Cover.jpg" alt="Audio S.O.S. - Tu Salvavidas" className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl object-cover shadow-lg border-2 border-gold/20" data-id="element-31" />

                <div className="space-y-4 text-brown-light text-lg leading-relaxed" data-id="element-32">
                  <p data-id="element-33">
                    Sé que hay momentos donde no puedes ni leer una página. Por
                    eso, grabé para ti un audio de acompañamiento.
                  </p>
                  <p data-id="element-34">
                    Ponlo en tus audífonos cuando sientas que vas a estallar; mi
                    voz te guiará de regreso a la calma en menos de 3 minutos.
                  </p>
                  <p className="font-medium text-brown italic" data-id="element-35">
                    Es como tener un ancla de paz en tu bolsillo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}